<template>
    <keep-alive>
        <router-view></router-view>
    </keep-alive>
</template>

<script>
export default {
    name: "BankAccount"
};
</script>



// WEBPACK FOOTER //
// src/view/bankAc/layout.vue